import type { FC } from 'react';
import { Dropdown } from 'antd';
import type { NodeProgressStatus, NodeTimeStatus } from '../../utils/nodeStatus';
import { getNodeProgressOptions } from '../../utils/nodeStatus';
import { useIpcStatusEnums } from '../../utils/useIpcStatusEnums';
import { IpcNodeStatus } from './IpcNodeStatus';

export type IpcNodeStatusPickerProps = {
  progress: NodeProgressStatus;
  time?: NodeTimeStatus;
  onChange: (progress: NodeProgressStatus) => void;
  disabled?: boolean;
  saving?: boolean;
  className?: string;
  /** 默认 true；极窄列可 false 仅显示圆点 */
  showLabel?: boolean;
  /** 不允许选择的进度状态（如自动完成节点禁止选「已完成」） */
  excludeProgress?: NodeProgressStatus[];
};

/** 可编辑节点状态：外观与 IpcNodeStatus 一致，点击展开三态菜单 */
export const IpcNodeStatusPicker: FC<IpcNodeStatusPickerProps> = ({
  progress,
  time = 'normal',
  onChange,
  disabled = false,
  saving = false,
  className,
  showLabel = true,
  excludeProgress,
}) => {
  useIpcStatusEnums();
  const excluded = new Set(excludeProgress ?? []);
  const options = getNodeProgressOptions().filter(opt => !excluded.has(opt.value));

  return (
    <Dropdown
      menu={{
        items: options.map(opt => ({
          key: opt.value,
          label: opt.label,
          onClick: () => onChange(opt.value),
        })),
        selectable: true,
        selectedKeys: [progress],
      }}
      trigger={['click']}
      disabled={disabled || saving}
    >
      <button
        type="button"
        className={[
          'ipc-node-status-picker',
          saving ? 'ipc-node-status-picker--saving' : '',
          className,
        ].filter(Boolean).join(' ')}
        aria-label="修改节点状态"
      >
        <IpcNodeStatus progress={progress} time={time} compact showLabel={showLabel} />
      </button>
    </Dropdown>
  );
};
